import { type HttpGet, buildQueryString, mapServerError } from '@/shared/infra/http'
import { huntTypeFromWire, HUNT_TYPES } from '@/shared/domain'
import type { LoadHuntTypesWithActivity } from '@/shared/domain'

export class EdgeLoadHuntTypesWithActivityRepository {
  constructor(private readonly http: HttpGet) {}

  execute: LoadHuntTypesWithActivity = async (params) => {
    try {
      const response = await this.http.get<{ huntTypes: string[] }>({
        url: `/stats/hunt-type-activity${buildQueryString({
          orgId: params.orgContext.orgId,
          orgType: params.orgContext.orgType,
        })}`,
      })
      const mapped = (response.huntTypes ?? []).map(huntTypeFromWire)
      return HUNT_TYPES.filter((t) => mapped.includes(t))
    } catch (err) {
      mapServerError(err)
    }
  }
}
